import Vue from 'vue'
import store from '../../config/vuex';

Vue.prototype.$moment = window.moment;

/**
 * @description 格式化金额
 * @param number：要格式化的数字
 * @param decimals：保留几位小数 默认0位
 * @param decPoint：小数点符号 默认.
 * @param thousandsSep：千分位符号 默认为,
 */
Vue.prototype.$formatMoney = (number, decimals = 2, decPoint = '.', thousandsSep = ',') => {
    number = (number + '').replace(/[^0-9+-Ee.]/g, '')
    let n = !isFinite(+number) ? 0 : +number
    let prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    let sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    let dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    let s = ''
    let toFixedFix = function (n, prec) {
        let k = Math.pow(10, prec)
        return '' + Math.ceil(n * k) / k
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    let re = /(-?\d+)(\d{3})/
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, '$1' + sep + '$2')
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    if (s[1] == '00') {
        return s[0]
    } else {
        return s.join(dec)
    }
}

/**
 * 文件url转换
 */
Vue.prototype.$formatFile = (url) => {
    return sessionStorage.fileURL + url;
}

Vue.prototype.$queryUrlParams = (url) => {
    var paramArr = url.split("?")[1] ? url.split("?")[1].split("&") : null;
    var json = {};
    if (paramArr) {
        paramArr.forEach((item) => {
            var itemArr = item.split("=");
            json[itemArr[0]] = decodeURIComponent(itemArr[1].replace(/%20/g, '+').split('#/')[0]);
        })
    }
    return json;
}

/**
 * 转换时间，精确到秒或分钟
 * @param {*} value 时长（秒）
 * @param {*} unit 返回单位（秒或分钟）
 */
Vue.prototype.$transTime = function (value, unit) {
    if (value == 0 || !value) {
        if (unit == 'second') return '0秒';
        if (unit == 'minute') return '0分钟';
    }
    var secondTime = parseInt(value); // 秒
    var minuteTime = 0; // 分
    var hourTime = 0; // 小时
    var dayTime = 0; // 天
    if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
            hourTime = parseInt(minuteTime / 60);
            minuteTime = parseInt(minuteTime % 60);
            if (hourTime >= 24) {
                dayTime = parseInt(hourTime / 24);
                hourTime = parseInt(hourTime % 24);
            }
        }
    }
    secondTime = parseInt(secondTime);
    var result = secondTime + "秒";

    if (unit == 'second') {
        if (minuteTime > 0) {
            minuteTime = parseInt(minuteTime);
            result = minuteTime + "分钟" + (secondTime > 0 ? secondTime + "秒" : '');
        }
        if (hourTime > 0) {
            hourTime = parseInt(hourTime);
            result = hourTime + "小时" + (minuteTime > 0 ? minuteTime + "分钟" : '') + (secondTime > 0 ? secondTime + "秒" : '');
        }
        if (dayTime > 0) {
            dayTime = parseInt(dayTime);
            result = dayTime + "天" + (hourTime > 0 ? hourTime + "小时" : '') + (minuteTime > 0 ? minuteTime + "分钟" : '') + (secondTime > 0 ? secondTime + "秒" : '');
        }
    }

    if (unit == 'minute') {
        if (minuteTime <= 0 && hourTime <= 0) {
            result = '1分钟';
        } else {
            if (secondTime >= 30) {
                minuteTime++;
            }
            if (minuteTime > 0) {
                minuteTime = parseInt(minuteTime);
                result = minuteTime + "分钟";
            }
            if (hourTime > 0) {
                hourTime = parseInt(hourTime);
                result = hourTime + "小时" + (minuteTime > 0 ? minuteTime + "分钟" : '');
            }
            if (dayTime > 0) {
                dayTime = parseInt(dayTime);
                result = dayTime + "天" + (hourTime > 0 ? hourTime + "小时" : '') + (minuteTime > 0 ? minuteTime + "分钟" : '');
            }
        }
    }
    return result;
}

/**
 * 计算时长
 * @param {*} startT 开始时间
 * @param {*} endT 结束时间
 * @param {*} type 类型：string时间字符串（YYYY-MM-DD HH:mm:ss），timestamp时间戳
 * @param {*} returnUnit 返回单位：minute/second
 */
Vue.prototype.$countDuration = function (startT, endT, type, returnUnit) {
    var startTimestamp = 0,
        endTimestamp = 0;
    if (type == 'timestamp') {
        startTimestamp = startT;
        endTimestamp = endT;
    } else if (type == 'string') {
        startTimestamp = (new Date(startT.replace(/-/g, '/')).getTime()) / 1000;
        endTimestamp = (new Date(endT.replace(/-/g, '/')).getTime()) / 1000;
    }
    return Vue.prototype.$transTime((endTimestamp - startTimestamp), returnUnit);
}


/**
 * 判断是否为微信浏览器
 */
Vue.prototype.$isWeixin = function () {
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true;
    } else {
        return false;
    }
}

/**
 * 判断是否为微信小程序
 */
Vue.prototype.$isWeixinApp = function () {
    return window.__wxjs_environment === 'miniprogram'
}

/**
 * 判断是否为PC端商城
 */
Vue.prototype.$isPc = function () {
    return this.$route.matched[0].path == '/mallHomepage';
}
Vue.prototype.$judgeDeviceType = function () {
    var ua = window.navigator.userAgent.toLocaleLowerCase();
    var isIOS = /iphone|ipad|ipod/.test(ua);
    var isAndroid = /android/.test(ua);
    return {
        isIOS: isIOS,
        isAndroid: isAndroid
    };
}

//日志打印
Vue.prototype.$LonbonLog = function (desc, log) {
    var time = window.moment().format("YYYY-MM-DD HH:mm:ss");
    console.log(time + ' ' + desc + ' ' + log);
    store.state.webLogData.unshift({
        time: time,
        desc: desc,
        log: log
    });
}

/**
 * 去空格
 */
Vue.prototype.$trim = {
    left: function (str) {
        return str.replace(/^\s*/, '');
    },
    right: function (str) {
        return str.replace(/(\s*$)/g, "");
    },
    around: function (str) {
        return str.replace(/^\s+|\s+$/g, "");
    },
    all: function (str) {
        return str.replace(/\s+/g, "");
    }
}


// WEBPACK FOOTER //
// ./src/components/common/tool.js